import { useTranslation } from 'react-i18next'
import { MultiSelect, type MultiSelectOption } from '@/components/ui/multi-select'

interface CurrencyMultiSelectProps {
    currencies: string[]
    selected: string[]
    onChange: (selected: string[]) => void
    placeholder?: string
    disabled?: boolean
    className?: string
}

const createCurrencyOptions = (currencies: string[]): MultiSelectOption<string>[] => {
    return currencies.map((currency) => ({
        label: currency,
        value: currency,
    }))
}

/**
 * Currency multi-select component
 * Allows selecting multiple currencies from a list
 */
export const CurrencyMultiSelect = ({
    currencies,
    selected,
    onChange,
    placeholder,
    disabled = false,
    className,
}: CurrencyMultiSelectProps) => {
    const { t } = useTranslation('common')
    const options = createCurrencyOptions(currencies)

    return (
        <MultiSelect
            options={options}
            selected={selected}
            onChange={onChange}
            placeholder={placeholder ?? t('currencySelect.multiPlaceholder')}
            emptyMessage={t('currencySelect.noCurrenciesFound')}
            searchPlaceholder={t('currencySelect.searchPlaceholder')}
            disabled={disabled}
            className={className}
            maxCount={3}
        />
    )
}

